module.exports = __webpack_public_path__ + "media/images/donation-screenshot-d160a9bfb3acd91631d8e638d33b1fec.png";